import { createTheme } from '@mui/material'
import { border } from './border'
import { themeColor, xxllncColor } from './color'
import { typography } from './typography'
import { surface } from './semanticTokens'

const material = createTheme()

export const button = {
  primary: {
    default: {
      backgroundColor: themeColor.blue,
      color: surface.white,
    },
    hover: {
      backgroundColor: themeColor.blue80,
      color: surface.white,
    },
    disabled: {
      backgroundColor: themeColor.slate10,
      color: themeColor.slate40,
    },
  },
  positive: {
    default: {
      backgroundColor: xxllncColor.green100,
      color: surface.white,
    },
    hover: {
      backgroundColor: xxllncColor.green80,
      color: surface.white,
    },
    disabled: {
      backgroundColor: themeColor.slate10,
      color: themeColor.slate40,
    },
  },
  negative: {
    default: {
      backgroundColor: xxllncColor.red100,
      color: surface.white,
    },
    hover: {
      backgroundColor: xxllncColor.red80,
      color: surface.white,
    },
    disabled: {
      backgroundColor: themeColor.slate10,
      color: themeColor.slate40,
    },
  },
  warning: {
    default: {
      backgroundColor: xxllncColor.orange100,
      color: surface.white,
    },
    hover: {
      backgroundColor: xxllncColor.orange80,
      color: surface.white,
    },
    disabled: {
      backgroundColor: themeColor.slate10,
      color: themeColor.slate40,
    },
  },
  info: {
    default: {
      backgroundColor: themeColor.slate,
      color: surface.white,
    },
    hover: {
      backgroundColor: themeColor.slate80,
      color: surface.white,
    },
    disabled: {
      backgroundColor: themeColor.slate10,
      color: themeColor.slate40,
    },
  },
  digid: {
    default: {
      fontFamily: typography.button,
      background: themeColor.black,
      border: border.thin + ' solid ' + themeColor.black,
      color: surface.white,
      padding: material.spacing(4),
    },
    hover: {
      background: themeColor.slate80,
      borderColor: themeColor.slate80,
    },
  },
  delete: {
    default: {
      background: 'transparent',
      padding: material.spacing(.75, 2),
      color: themeColor.slate,
      fill: xxllncColor.red100,
    },
    hover: {
      background: 'rgba(194, 67, 66, 0.1)',
    }
  }
}
